import { render } from "./EditMessage.vue?vue&type=template&id=6ef6f467"
import script from "./EditMessage.vue?vue&type=script&lang=js"
export * from "./EditMessage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__